import AddressService from './services/addressService'

const addAddressToMetafield = () => {
  var customer = global.FFJP.customerDefaultAddress

  if (
    typeof customer !== 'undefined' &&
    window.localStorage.getItem('kana_last_name')
  ) {
    var province_id = customer.province_code
      ? customer.province_code.replace('JP-0', '').replace('JP-', '')
      : ''
    var province_name = globalThis.jpPrefecture.findBy(
      'pref',
      'id',
      Number(province_id)
    ).name
    customer.name = customer.last_name + ' ' + customer.first_name
    customer.kana_last_name = window.localStorage.getItem('kana_last_name')
    customer.kana_first_name = window.localStorage.getItem('kana_first_name')
    customer.elevator = window.localStorage.getItem('haselevator')
    customer.floor = window.localStorage.getItem('floor')
    customer.roomsize = window.localStorage.getItem('roomsize')
    customer.province = province_name

    AddressService.newAddress(customer).done(() => {
      window.localStorage.removeItem('kana_last_name')
      window.localStorage.removeItem('kana_first_name')
      window.localStorage.removeItem('haselevator')
      window.localStorage.removeItem('floor')
      window.localStorage.removeItem('roomsize')
    })
  }
}

export default addAddressToMetafield
